import React from 'react';
import useWithStore from "@/Hooks/useWithStore";
import {Collapse} from "@mui/material";

class JobsItem extends React.Component {
    state = {
        checked0: false,
        checked1: false,
        checked2: false,
        checked3: false,
        checked4: false,
        checked5: false,
        checked6: false,
        checked7: false,
        checked8: false,
        checked9: false,
        checked10: false,
        checked11: false,
        checked12: false,
    }

    //Меняем динамические состояния для вакансий
    toggleReviews(id) {
        this.setState({[`checked${id}`]: !this.state[`checked${id}`]});
    }


    render() {
        const {modalStore = {}} = this.props.stores;

        return <>
            {/*<div className={`jobs__item`}>*/}
            {/*    <p className={`jobs__title js-jobs-title`}>*/}
            {/*        Менеджер по работе с розничными клиентами*/}
            {/*    </p>*/}
            {/*    <Collapse in={this.state.checked0}*/}
            {/*              collapsedSize={55}*/}
            {/*    >*/}
            {/*        <p className={`jobs__subtitle`}>*/}
            {/*            Место работы:*/}
            {/*        </p>*/}
            {/*        <div className={`jobs__description`}>*/}
            {/*            <p>*/}
            {/*                Ювелирный магазин "PLATINA" г. Москва, ул. Большая Дорогомиловская, 8 (напротив ТРЦ*/}
            {/*                «Европейский»)*/}
            {/*            </p>*/}
            {/*        </div>*/}
            {/*        <p className={`jobs__subtitle`}>*/}
            {/*            Новому сотруднику предстоит:*/}
            {/*        </p>*/}
            {/*        <div className={`jobs__description`}>*/}
            {/*            <p>*/}
            {/*                Общаться и консультировать покупателей по ассортименту, качеству и преимуществу товара,*/}
            {/*                помогая совершить приятную и выгодную покупку;*/}
            {/*            </p>*/}
            {/*            <p>*/}
            {/*                Обслуживать покупателей на кассе;*/}
            {/*            </p>*/}
            {/*            <p>*/}
            {/*                Осуществлять предпродажную подготовку товара и обеспечивать выкладку согласно стандартам;*/}
            {/*            </p>*/}
            {/*            <p>*/}
            {/*                Поддерживать порядок и уют в торговом зале;*/}
            {/*            </p>*/}
            {/*            <p>*/}
            {/*                Соблюдать правила трудовой дисциплины и стандарты работы;*/}
            {/*            </p>*/}
            {/*            <p>*/}
            {/*                Принимать участие в инвентаризациях;*/}
            {/*            </p>*/}
            {/*            <p>*/}
            {/*                Вести учет товарно-материальных ценностей и обеспечивать их сохранность;*/}
            {/*            </p>*/}
            {/*            <p>*/}
            {/*                Работать в команде и достигать плановых показателей.*/}
            {/*            </p>*/}
            {/*        </div>*/}
            {/*        <p className={`jobs__subtitle`}>*/}
            {/*            Требования:*/}
            {/*        </p>*/}
            {/*        <div className={`jobs__description`}>*/}
            {/*            <p>*/}
            {/*                Опыт работы: 1–3 года;*/}
            {/*            </p>*/}
            {/*            <p>*/}
            {/*                Владение грамотной речью, желание профессионально общаться с людьми;*/}
            {/*            </p>*/}
            {/*            <p>*/}
            {/*                Доброжелательное настроение к покупателям и готовность делиться хорошим настроением и*/}
            {/*                оптимизмом;*/}
            {/*            </p>*/}
            {/*            <p>*/}
            {/*                Желание добиваться значимых результатов для себя и коллектива;*/}
            {/*            </p>*/}
            {/*            <p>*/}
            {/*                Отсутствие боязни ответственности и умение организовать себя;*/}
            {/*            </p>*/}
            {/*            <p>*/}
            {/*                Средне-специальное образование и выше, желание учиться и позитивно встречать новое;*/}
            {/*            </p>*/}
            {/*        </div>*/}
            {/*        <p className={`jobs__subtitle`}>*/}
            {/*            Мы&nbsp;предлагаем:*/}
            {/*        </p>*/}
            {/*        <div className={`jobs__description`}>*/}
            {/*            <p>*/}
            {/*                Удобный сменный график (3/2 и 2/2, минимум 16 смен в месяце);*/}
            {/*            </p>*/}
            {/*            <p>*/}
            {/*                Режим работы магазина: 10.00 до 21.00*/}
            {/*            </p>*/}
            {/*            <p>*/}
            {/*                Гарантированный стабильный финансовый доход;*/}
            {/*            </p>*/}
            {/*            <p>*/}
            {/*                Социальные гарантии и оформление в соответствии с ТК РФ с первого дня работы;*/}
            {/*            </p>*/}
            {/*            <p>*/}
            {/*                Работу в дружном коллективе.*/}
            {/*            </p>*/}
            {/*        </div>*/}
            {/*    </Collapse>*/}
            {/*    <div className={`jobs__buttons`}>*/}
            {/*        <div className={`jobs__more`}*/}
            {/*             onClick={() => this.toggleReviews(0)}>*/}
            {/*            {this.state.checked0 ? 'Скрыть' : 'Подробнее'}*/}
            {/*        </div>*/}
            {/*        <div className={`jobs__more`}*/}
            {/*             onClick={() => modalStore.openModalJobsForm('Менеджер по работе с розничными клиентами')}>*/}
            {/*            Откликнуться*/}
            {/*        </div>*/}
            {/*    </div>*/}
            {/*</div>*/}
            <div className={`jobs__item`}>
                <p className={`jobs__title js-jobs-title`}>
                    Программист 1C
                </p>
                <Collapse in={this.state.checked1}
                          collapsedSize={55}
                >
                    <p className={`jobs__subtitle`}>
                        Место работы:
                    </p>
                    <div className={`jobs__description`}>
                        <p>
                            Офис в Красном-на-Волге (Костромская область)
                        </p>
                    </div>
                    <p className={`jobs__subtitle`}>
                        Новому сотруднику предстоит:
                    </p>
                    <div className={`jobs__description`}>
                        <p>
                            Автоматизация деятельности компании на&nbsp;базе 1С&nbsp;&laquo;Предприятие&raquo; 8.3;
                        </p>
                        <p>
                            Сопровождение стандартных и&nbsp;не&nbsp;типовых конфигураций на&nbsp;базе 1С. Доработка
                            функционала по&nbsp;ТЗ;
                        </p>
                        <p>
                            Создание новых и&nbsp;модификация существующих документов, справочников, отчетов
                            и&nbsp;обработок;
                        </p>
                        <p>
                            Обновление конфигураций, исправление ошибок, оптимизация программного кода;
                        </p>
                        <p>
                            Консультирование и&nbsp;обучение пользователей, решение вставших перед ними проблем;
                        </p>
                        <p>
                            Разработка средств интеграции и&nbsp;взаимодействия между различными конфигурациями
                            1С&nbsp;и&nbsp;сторонними системами.
                        </p>
                    </div>
                    <p className={`jobs__subtitle`}>
                        Требования:
                    </p>
                    <div className={`jobs__description`}>
                        <p>
                            Высшее техническое образование;
                        </p>
                        <p>
                            Знание и&nbsp;применение системы стандартов и&nbsp;методик разработки конфигураций для
                            платформы 1с&nbsp;8.3;
                        </p>
                        <p>
                            Знание СКД, знание языка запросов, понимание принципов работы клиент-серверных
                            приложений, управляемых форм;
                        </p>
                        <p>
                            Аналитическое мышление, умение и&nbsp;желание заниматься поддержкой, ответственность,
                            работа в&nbsp;команде;
                        </p>
                        <p>
                            Умение самостоятельно прорабатывать задачи, детализировать требования пользователей,
                            разрабатывать оптимальные решения, использовать системный подход к&nbsp;решению задач;
                        </p>
                        <p>
                            Желателен опыт работы с&nbsp;торговым оборудованием (Онлайн кассы, сканеры&nbsp;ШК,
                            pos-терминалы и&nbsp;т.д.);
                        </p>
                        <p>
                            Приветствуется знание основ бухгалтерского и&nbsp;оперативного учета.
                        </p>
                    </div>
                    <p className={`jobs__subtitle`}>
                        Мы&nbsp;предлагаем:
                    </p>
                    <div className={`jobs__description`}>
                        <p>
                            Работу в&nbsp;динамично растущей российской компании, отличные возможности проявить
                            себя;
                        </p>
                        <p>Хорошие возможности для карьерного роста;</p>
                        <p>
                            Высокая з/п по&nbsp;результатам собеседования;
                        </p>
                        <p>
                            Комфортные условия труда;
                        </p>
                        <p>
                            Полностью официальное оформление;
                        </p>
                        <p>
                            Пятидневка с 9.00 до 17.30;
                        </p>
                        <p>
                            Доставка на&nbsp;работу транспортом предприятия.
                        </p>
                    </div>
                </Collapse>
                <div className={`jobs__buttons`}>
                    <div className={`jobs__more`}
                         onClick={() => this.toggleReviews(1)}>
                        {this.state.checked1 ? 'Скрыть' : 'Подробнее'}
                    </div>
                    <div className={`jobs__more`}
                         onClick={() => modalStore.openModalJobsForm('Программист 1C')}>
                        Откликнуться
                    </div>
                </div>
            </div>
            {/*<div className={`jobs__item`}>*/}
            {/*    <p className={`jobs__title js-jobs-title`}>*/}
            {/*        Веб дизайнер / Web designer*/}
            {/*    </p>*/}
            {/*    <Collapse in={this.state.checked2}*/}
            {/*              collapsedSize={55}*/}
            {/*    >*/}
            {/*        <p className={`jobs__subtitle`}>*/}
            {/*            Место работы:*/}
            {/*        </p>*/}
            {/*        <div className={`jobs__description`}>*/}
            {/*            <p>*/}
            {/*                Офис в Костроме*/}
            {/*            </p>*/}
            {/*        </div>*/}
            {/*        <p className={`jobs__subtitle`}>*/}
            {/*            Новому сотруднику предстоит:*/}
            {/*        </p>*/}
            {/*        <div className={`jobs__description`}>*/}
            {/*            <p>*/}
            {/*                Разработка и&nbsp;адаптация дизайн-макетов;*/}
            {/*            </p>*/}
            {/*            <p>*/}
            {/*                Концепций рекламных кампаний (макеты наружной рекламы, рекламы в&nbsp;прессе, мастер*/}
            {/*                макет, POS и&nbsp;др. рекламных носителей);*/}
            {/*            </p>*/}
            {/*            <p>*/}
            {/*                Обработка фото, ретушь, цветокоррекция;*/}
            {/*            </p>*/}
            {/*            <p>*/}
            {/*                Работа над внутренними проектами компании.*/}
            {/*            </p>*/}
            {/*            <p>*/}
            {/*                Разработка дизайн-концепций web-сайтов и&nbsp;посадочных страниц;*/}
            {/*            </p>*/}
            {/*        </div>*/}
            {/*        <p className={`jobs__subtitle`}>*/}
            {/*            Требования:*/}
            {/*        </p>*/}
            {/*        <div className={`jobs__description`}>*/}
            {/*            <p>*/}
            {/*                Опыт работы в&nbsp;аналогичной сфере от&nbsp;2&nbsp;лет;*/}
            {/*            </p>*/}
            {/*            <p>*/}
            {/*                Обязательно профессиональное владение пакетом Adobe + Figma;*/}
            {/*            </p>*/}
            {/*            <p>*/}
            {/*                Знание основ допечатных процессов и&nbsp;подготовки макетов разного уровня сложности,*/}
            {/*                умение работать с&nbsp;техническими требованиями;*/}
            {/*            </p>*/}
            {/*            <p>*/}
            {/*                Желательно иметь ПОРТФОЛИО по&nbsp;каждому из&nbsp;направлений, в&nbsp;котором есть*/}
            {/*                работы.*/}
            {/*            </p>*/}
            {/*        </div>*/}
            {/*        <p className={`jobs__subtitle`}>*/}
            {/*            Мы&nbsp;предлагаем:*/}
            {/*        </p>*/}
            {/*        <div className={`jobs__description`}>*/}
            {/*            <p>*/}
            {/*                Пятидневка с&nbsp;9:00 до&nbsp;17:30*/}
            {/*            </p>*/}
            {/*            <p>*/}
            {/*                Заработная плата по&nbsp;итогам собеседования;*/}
            {/*            </p>*/}
            {/*            <p>*/}
            {/*                Гарантированный стабильный финансовый доход;*/}
            {/*            </p>*/}
            {/*            <p>*/}
            {/*                Работу в&nbsp;дружном коллективе.*/}
            {/*            </p>*/}
            {/*        </div>*/}
            {/*    </Collapse>*/}
            {/*    <div className={`jobs__buttons`}>*/}
            {/*        <div className={`jobs__more`}*/}
            {/*             onClick={() => this.toggleReviews(2)}>*/}
            {/*            {this.state.checked2 ? 'Скрыть' : 'Подробнее'}*/}
            {/*        </div>*/}
            {/*        <div className={`jobs__more`}*/}
            {/*             onClick={() => modalStore.openModalJobsForm('Веб дизайнер / Web designer')}>*/}
            {/*            Откликнуться*/}
            {/*        </div>*/}
            {/*    </div>*/}
            {/*</div>*/}
            <div className={`jobs__item`}>
                <p className={`jobs__title js-jobs-title`}>
                    Интернет-маркетолог
                </p>
                <Collapse in={this.state.checked3}
                          collapsedSize={55}
                >
                    <p className={`jobs__subtitle`}>
                        Место работы:
                    </p>
                    <div className={`jobs__description`}>
                        <p>
                            Офис в Красном-на-Волге (Костромская область)
                        </p>
                    </div>
                    <p className={`jobs__subtitle`}>
                        Новому сотруднику предстоит:
                    </p>
                    <div className={`jobs__description`}>
                        <p>
                            Работа с интернет-рекламой (контекстная реклама Яндекс Директ), таргетированной рекламой
                            ВКонтакте, MyTarget;
                        </p>
                        <p>
                            Постановка задач, контроль сроков и качества исполнения;
                        </p>
                        <p>
                            Аналитика и отчетность.
                        </p>
                    </div>
                    <p className={`jobs__subtitle`}>
                        Требования:
                    </p>
                    <div className={`jobs__description`}>
                        <p>
                            Высшее образование;
                        </p>
                        <p>
                            Опыт работы с контекстной рекламой;
                        </p>
                        <p>
                            Желателен опыт работы с таргетированной рекламой;
                        </p>
                        <p>
                            Приветствуется опыт работы с e-mail рассылками;
                        </p>
                        <p>
                            Высокая вовлеченность в процесс.
                        </p>
                    </div>
                    <p className={`jobs__subtitle`}>
                        Мы&nbsp;предлагаем:
                    </p>
                    <div className={`jobs__description`}>
                        <p>
                            Пятидневка с&nbsp;9:00 до&nbsp;17:30
                        </p>
                        <p>
                            Адекватная заработная плата, размер которой обсуждается с кандидатом;
                        </p>
                        <p>
                            Полностью официальное оформление;
                        </p>
                        <p>
                            Профессиональный рост;
                        </p>
                        <p>
                            Доставка на&nbsp;работу транспортом предприятия.
                        </p>
                    </div>
                </Collapse>
                <div className={`jobs__buttons`}>
                    <div className={`jobs__more`}
                         onClick={() => this.toggleReviews(3)}>
                        {this.state.checked3 ? 'Скрыть' : 'Подробнее'}
                    </div>
                    <div className={`jobs__more`}
                         onClick={() => modalStore.openModalJobsForm('Интернет-маркетолог')}>
                        Откликнуться
                    </div>
                </div>
            </div>
            {/*<div className={`jobs__item`}>*/}
            {/*    <p className={`jobs__title js-jobs-title`}>*/}
            {/*        Менеджер по оптовым продажам*/}
            {/*    </p>*/}
            {/*    <Collapse in={this.state.checked4}*/}
            {/*              collapsedSize={55}*/}
            {/*    >*/}
            {/*        <p className={`jobs__subtitle`}>*/}
            {/*            Место работы:*/}
            {/*        </p>*/}
            {/*        <div className={`jobs__description`}>*/}
            {/*            <p>*/}
            {/*                Офис в Красном-на-Волге (Костромская область)*/}
            {/*            </p>*/}
            {/*        </div>*/}
            {/*        <p className={`jobs__subtitle`}>*/}
            {/*            Новому сотруднику предстоит:*/}
            {/*        </p>*/}
            {/*        <div className={`jobs__description`}>*/}
            {/*            <p>*/}
            {/*                Выполнение личного плана продаж;*/}
            {/*            </p>*/}
            {/*            <p>*/}
            {/*                Ведение коммерческих переговоров;*/}
            {/*            </p>*/}
            {/*            <p>*/}
            {/*                Организация подготовки партии продукции к отправке в установленные сроки и в полном*/}
            {/*                объёме.*/}
            {/*            </p>*/}
            {/*            <p>*/}
            {/*                Подготовка, заключение и переоформление договоров;*/}
            {/*            </p>*/}
            {/*            <p>*/}
            {/*                Осуществление контроля и обеспечение своевременного и полного погашения дебиторской*/}
            {/*                задолженности;*/}
            {/*            </p>*/}
            {/*            <p>*/}
            {/*                Осуществление контроля оплаты по заключенным договорам;*/}
            {/*            </p>*/}
            {/*            <p>*/}
            {/*                Организация и поиск потенциальных клиентов;*/}
            {/*            </p>*/}
            {/*            <p>*/}
            {/*                Обеспечение своевременного получения всей рабочей и любой отчётной документации;*/}
            {/*            </p>*/}
            {/*            <p>*/}
            {/*                Участие в специализированных выставках.*/}
            {/*            </p>*/}
            {/*        </div>*/}
            {/*        <p className={`jobs__subtitle`}>*/}
            {/*            Требования:*/}
            {/*        </p>*/}
            {/*        <div className={`jobs__description`}>*/}
            {/*            <p>*/}
            {/*                Опыт работы в продажах от 3-х лет;*/}
            {/*            </p>*/}
            {/*            <p>*/}
            {/*                Высшее образование;*/}
            {/*            </p>*/}
            {/*            <p>*/}
            {/*                Успешный опыт ведения переговоров на различных уровнях;*/}
            {/*            </p>*/}
            {/*            <p>*/}
            {/*                Высокий уровень владения ПК (MS Office, 1С);*/}
            {/*            </p>*/}
            {/*            <p>*/}
            {/*                Грамотная устная и письменная речь;*/}
            {/*            </p>*/}
            {/*            <p>*/}
            {/*                Высокий уровень коммуникабельности;*/}
            {/*            </p>*/}
            {/*            <p>*/}
            {/*                Нацеленность на результат и профессиональное развитие.*/}
            {/*            </p>*/}
            {/*        </div>*/}
            {/*        <p className={`jobs__subtitle`}>*/}
            {/*            Мы&nbsp;предлагаем:*/}
            {/*        </p>*/}
            {/*        <div className={`jobs__description`}>*/}
            {/*            <p>*/}
            {/*                График работы 5/2, с 9:00 до 17.30;*/}
            {/*            </p>*/}
            {/*            <p>*/}
            {/*                Доставка на работу транспортом компании;*/}
            {/*            </p>*/}
            {/*            <p>*/}
            {/*                Стабильная заработная плата;*/}
            {/*            </p>*/}
            {/*            <p>*/}
            {/*                Официальное трудоустройство;*/}
            {/*            </p>*/}
            {/*            <p>*/}
            {/*                Полный социальный пакет;*/}
            {/*            </p>*/}
            {/*            <p>*/}
            {/*                Обучение и наставничество, корпоративное обучение;*/}
            {/*            </p>*/}
            {/*            <p>*/}
            {/*                Возможность профессионального и карьерного роста;*/}
            {/*            </p>*/}
            {/*            <p>*/}
            {/*                Заработная плата по результатам собеседования.*/}
            {/*            </p>*/}
            {/*        </div>*/}
            {/*    </Collapse>*/}
            {/*    <div className={`jobs__buttons`}>*/}
            {/*        <div className={`jobs__more`}*/}
            {/*             onClick={() => this.toggleReviews(4)}>*/}
            {/*            {this.state.checked4 ? 'Скрыть' : 'Подробнее'}*/}
            {/*        </div>*/}
            {/*        <div className={`jobs__more`}*/}
            {/*             onClick={() => modalStore.openModalJobsForm('Менеджер по оптовым продажам')}>*/}
            {/*            Откликнуться*/}
            {/*        </div>*/}
            {/*    </div>*/}
            {/*</div>*/}
            {/*<div className={`jobs__item`}>*/}
            {/*    <p className={`jobs__title js-jobs-title`}>*/}
            {/*        Учетчик*/}
            {/*    </p>*/}
            {/*    <Collapse in={this.state.checked5}*/}
            {/*              collapsedSize={55}*/}
            {/*    >*/}
            {/*        <p className={`jobs__subtitle`}>*/}
            {/*            Место работы:*/}
            {/*        </p>*/}
            {/*        <div className={`jobs__description`}>*/}
            {/*            <p>*/}
            {/*                Ювелирный завод в Красном-на-Волге (Костромская область)*/}
            {/*            </p>*/}
            {/*        </div>*/}
            {/*        <p className={`jobs__subtitle`}>*/}
            {/*            Новому сотруднику предстоит:*/}
            {/*        </p>*/}
            {/*        <div className={`jobs__description`}>*/}
            {/*            <p>*/}
            {/*                Вести учет (прием, взвешивание, хранение и выдача материальных ценностей) полуфабрикатов*/}
            {/*                ювелирных изделий после технологических процессов, осуществляемых на технологических*/}
            {/*                участках;*/}
            {/*            </p>*/}
            {/*            <p>*/}
            {/*                Учет наличия на складе хранящихся материальных ценностей, ведение отчетной документации по*/}
            {/*                их движению;*/}
            {/*            </p>*/}
            {/*            <p>*/}
            {/*                Формирование нарядов на выполнение работы на закрепленном участке.*/}
            {/*            </p>*/}
            {/*        </div>*/}
            {/*        <p className={`jobs__subtitle`}>*/}
            {/*            Требования:*/}
            {/*        </p>*/}
            {/*        <div className={`jobs__description`}>*/}
            {/*            <p>*/}
            {/*                Опыт работы 1–3 года*/}
            {/*            </p>*/}
            {/*        </div>*/}
            {/*        <p className={`jobs__subtitle`}>*/}
            {/*            Мы&nbsp;предлагаем:*/}
            {/*        </p>*/}
            {/*        <div className={`jobs__description`}>*/}
            {/*            <p>*/}
            {/*                Полная занятость, полный день;*/}
            {/*            </p>*/}
            {/*            <p>*/}
            {/*                Высокая сдельная заработная плата;*/}
            {/*            </p>*/}
            {/*            <p>*/}
            {/*                Полностью официальное оформление;*/}
            {/*            </p>*/}
            {/*            <p>*/}
            {/*                Профессиональный рост;*/}
            {/*            </p>*/}
            {/*            <p>*/}
            {/*                Доставка на работу транспортом предприятия.*/}
            {/*            </p>*/}
            {/*        </div>*/}
            {/*    </Collapse>*/}
            {/*    <div className={`jobs__buttons`}>*/}
            {/*        <div className={`jobs__more`}*/}
            {/*             onClick={() => this.toggleReviews(5)}>*/}
            {/*            {this.state.checked5 ? 'Скрыть' : 'Подробнее'}*/}
            {/*        </div>*/}
            {/*        <div className={`jobs__more`}*/}
            {/*             onClick={() => modalStore.openModalJobsForm('Учетчик')}>*/}
            {/*            Откликнуться*/}
            {/*        </div>*/}
            {/*    </div>*/}
            {/*</div>*/}
            {/*<div className={`jobs__item`}>*/}
            {/*    <p className={`jobs__title js-jobs-title`}>*/}
            {/*        Ювелир лазерной пайки*/}
            {/*    </p>*/}
            {/*    <Collapse in={this.state.checked6}*/}
            {/*              collapsedSize={55}*/}
            {/*    >*/}
            {/*        <p className={`jobs__subtitle`}>*/}
            {/*            Место работы:*/}
            {/*        </p>*/}
            {/*        <div className={`jobs__description`}>*/}
            {/*            <p>*/}
            {/*                Ювелирный завод в Красном-на-Волге (Костромская область)*/}
            {/*            </p>*/}
            {/*        </div>*/}
            {/*        <p className={`jobs__subtitle`}>*/}
            {/*            Новому сотруднику предстоит:*/}
            {/*        </p>*/}
            {/*        <div className={`jobs__description`}>*/}
            {/*            <p>*/}
            {/*                Сборка всего спектра ювелирных украшений, при помощи лазерных установок.*/}
            {/*            </p>*/}
            {/*        </div>*/}
            {/*        <p className={`jobs__subtitle`}>*/}
            {/*            Требования:*/}
            {/*        </p>*/}
            {/*        <div className={`jobs__description`}>*/}
            {/*            <p>*/}
            {/*                Рассмотрим кандидатов с опытом работы и без опыта.*/}
            {/*            </p>*/}
            {/*        </div>*/}
            {/*        <p className={`jobs__subtitle`}>*/}
            {/*            Мы&nbsp;предлагаем:*/}
            {/*        </p>*/}
            {/*        <div className={`jobs__description`}>*/}
            {/*            <p>*/}
            {/*                Официальное оформление;*/}
            {/*            </p>*/}
            {/*            <p>*/}
            {/*                Высокая сдельная заработная плата;*/}
            {/*            </p>*/}
            {/*            <p>*/}
            {/*                Возможное совмещение;*/}
            {/*            </p>*/}
            {/*            <p>*/}
            {/*                Рабочий день с 8.00 до 17.00;*/}
            {/*            </p>*/}
            {/*            <p>*/}
            {/*                Доставка транспортом предприятия.*/}
            {/*            </p>*/}
            {/*        </div>*/}
            {/*    </Collapse>*/}
            {/*    <div className={`jobs__buttons`}>*/}
            {/*        <div className={`jobs__more`}*/}
            {/*             onClick={() => this.toggleReviews(6)}>*/}
            {/*            {this.state.checked6 ? 'Скрыть' : 'Подробнее'}*/}
            {/*        </div>*/}
            {/*        <div className={`jobs__more`}*/}
            {/*             onClick={() => modalStore.openModalJobsForm('Ювелир лазерной пайки')}>*/}
            {/*            Откликнуться*/}
            {/*        </div>*/}
            {/*    </div>*/}
            {/*</div>*/}
            {/*<div className={`jobs__item`}>*/}
            {/*    <p className={`jobs__title js-jobs-title`}>*/}
            {/*        Специалист на участок восковки (восковщица/восковщик)*/}
            {/*    </p>*/}
            {/*    <Collapse in={this.state.checked7}*/}
            {/*              collapsedSize={55}*/}
            {/*    >*/}
            {/*        <p className={`jobs__subtitle`}>*/}
            {/*            Место работы:*/}
            {/*        </p>*/}
            {/*        <div className={`jobs__description`}>*/}
            {/*            <p>*/}
            {/*                Ювелирный завод в Красном-на-Волге (Костромская область)*/}
            {/*            </p>*/}
            {/*        </div>*/}
            {/*        <p className={`jobs__subtitle`}>*/}
            {/*            Новому сотруднику предстоит:*/}
            {/*        </p>*/}
            {/*        <div className={`jobs__description`}>*/}
            {/*            <p>*/}
            {/*                Изготовление восковых моделей и полуфабрикатов ювелирных изделий;*/}
            {/*            </p>*/}
            {/*            <p>*/}
            {/*                Регулировка процессов восковки по приборам и заданным режимам.*/}
            {/*            </p>*/}
            {/*        </div>*/}
            {/*        <p className={`jobs__subtitle`}>*/}
            {/*            Требования:*/}
            {/*        </p>*/}
            {/*        <div className={`jobs__description`}>*/}
            {/*            <p>*/}
            {/*                Опыт работы на участке восковки желателен.*/}
            {/*            </p>*/}
            {/*        </div>*/}
            {/*        <p className={`jobs__subtitle`}>*/}
            {/*            Мы&nbsp;предлагаем:*/}
            {/*        </p>*/}
            {/*        <div className={`jobs__description`}>*/}
            {/*            <p>*/}
            {/*                Рабочий день с 8.00 до 17.00;*/}
            {/*            </p>*/}
            {/*            <p>*/}
            {/*                Высокая сдельная заработная плата;*/}
            {/*            </p>*/}
            {/*            <p>*/}
            {/*                Полностью официальное оформление;*/}
            {/*            </p>*/}
            {/*            <p>*/}
            {/*                Доставка на работу транспортом предприятия.*/}
            {/*            </p>*/}
            {/*        </div>*/}
            {/*    </Collapse>*/}
            {/*    <div className={`jobs__buttons`}>*/}
            {/*        <div className={`jobs__more`}*/}
            {/*             onClick={() => this.toggleReviews(7)}>*/}
            {/*            {this.state.checked7 ? 'Скрыть' : 'Подробнее'}*/}
            {/*        </div>*/}
            {/*        <div className={`jobs__more`}*/}
            {/*             onClick={() => modalStore.openModalJobsForm('Специалист на участок восковки (восковщица/восковщик)')}>*/}
            {/*            Откликнуться*/}
            {/*        </div>*/}
            {/*    </div>*/}
            {/*</div>*/}
            {/*<div className={`jobs__item`}>*/}
            {/*    <p className={`jobs__title js-jobs-title`}>*/}
            {/*        Алмазчик (огранщик) цепей*/}
            {/*    </p>*/}
            {/*    <Collapse in={this.state.checked8}*/}
            {/*              collapsedSize={55}*/}
            {/*    >*/}
            {/*        <p className={`jobs__subtitle`}>*/}
            {/*            Место работы:*/}
            {/*        </p>*/}
            {/*        <div className={`jobs__description`}>*/}
            {/*            <p>*/}
            {/*                Ювелирный завод в Красном-на-Волге (Костромская область)*/}
            {/*            </p>*/}
            {/*        </div>*/}
            {/*        <p className={`jobs__subtitle`}>*/}
            {/*            Новому сотруднику предстоит:*/}
            {/*        </p>*/}
            {/*        <div className={`jobs__description`}>*/}
            {/*            <p>*/}
            {/*                Сколотка цепей на прессах;*/}
            {/*            </p>*/}
            {/*            <p>*/}
            {/*                Нанесение алмазной грани на цепи;*/}
            {/*            </p>*/}
            {/*        </div>*/}
            {/*        <p className={`jobs__subtitle`}>*/}
            {/*            Требования:*/}
            {/*        </p>*/}
            {/*        <div className={`jobs__description`}>*/}
            {/*            <p>*/}
            {/*                Опыт работы 1-3 года.*/}
            {/*            </p>*/}
            {/*        </div>*/}
            {/*        <p className={`jobs__subtitle`}>*/}
            {/*            Мы&nbsp;предлагаем:*/}
            {/*        </p>*/}
            {/*        <div className={`jobs__description`}>*/}
            {/*            <p>*/}
            {/*                Полная занятость, полный день;*/}
            {/*            </p>*/}
            {/*            <p>*/}
            {/*                Высокая сдельная заработная плата;*/}
            {/*            </p>*/}
            {/*            <p>*/}
            {/*                Полностью официальное оформление;*/}
            {/*            </p>*/}
            {/*            <p>*/}
            {/*                Профессиональный рост;*/}
            {/*            </p>*/}
            {/*            <p>*/}
            {/*                Доставка на работу транспортом предприятия.*/}
            {/*            </p>*/}
            {/*        </div>*/}
            {/*    </Collapse>*/}
            {/*    <div className={`jobs__buttons`}>*/}
            {/*        <div className={`jobs__more`}*/}
            {/*             onClick={() => this.toggleReviews(8)}>*/}
            {/*            {this.state.checked8 ? 'Скрыть' : 'Подробнее'}*/}
            {/*        </div>*/}
            {/*        <div className={`jobs__more`}*/}
            {/*             onClick={() => modalStore.openModalJobsForm('Алмазчик (огранщик) цепей')}>*/}
            {/*            Откликнуться*/}
            {/*        </div>*/}
            {/*    </div>*/}
            {/*</div>*/}
            {/*<div className={`jobs__item`}>*/}
            {/*    <p className={`jobs__title js-jobs-title`}>*/}
            {/*        Контролер ОТК*/}
            {/*    </p>*/}
            {/*    <Collapse in={this.state.checked9}*/}
            {/*              collapsedSize={55}*/}
            {/*    >*/}
            {/*        <p className={`jobs__subtitle`}>*/}
            {/*            Место работы:*/}
            {/*        </p>*/}
            {/*        <div className={`jobs__description`}>*/}
            {/*            <p>*/}
            {/*                Ювелирный завод в Красном-на-Волге (Костромская область)*/}
            {/*            </p>*/}
            {/*        </div>*/}
            {/*        <p className={`jobs__subtitle`}>*/}
            {/*            Новому сотруднику предстоит:*/}
            {/*        </p>*/}
            {/*        <div className={`jobs__description`}>*/}
            {/*            <p>*/}
            {/*                Контроль качества полуфабриката ювелирных изделий после технологических процессов,*/}
            {/*                осуществляемых на технологических участках, по качеству обработки и сборки, отсутствию*/}
            {/*                облоя; отсутствию литьевых дефектов; соответствию изделию каталогу; качеству работы замков;*/}
            {/*                соответствию размеров; парности; отсутствию приобретенных дефектов – царапин, вмятин,*/}
            {/*                деформаций и т.д.*/}
            {/*            </p>*/}
            {/*        </div>*/}
            {/*        <p className={`jobs__subtitle`}>*/}
            {/*            Требования:*/}
            {/*        </p>*/}
            {/*        <div className={`jobs__description`}>*/}
            {/*            <p>*/}
            {/*                Опыт работы желателен. Но мы готовы рассмотреть соискателей и без опыта работы!*/}
            {/*            </p>*/}
            {/*        </div>*/}
            {/*        <p className={`jobs__subtitle`}>*/}
            {/*            Мы&nbsp;предлагаем:*/}
            {/*        </p>*/}
            {/*        <div className={`jobs__description`}>*/}
            {/*            <p>*/}
            {/*                Полная занятость, полный день;*/}
            {/*            </p>*/}
            {/*            <p>*/}
            {/*                Высокая сдельная заработная плата;*/}
            {/*            </p>*/}
            {/*            <p>*/}
            {/*                Полностью официальное оформление;*/}
            {/*            </p>*/}
            {/*            <p>*/}
            {/*                Профессиональный рост;*/}
            {/*            </p>*/}
            {/*            <p>*/}
            {/*                Доставка на работу транспортом предприятия.*/}
            {/*            </p>*/}
            {/*        </div>*/}
            {/*    </Collapse>*/}
            {/*    <div className={`jobs__buttons`}>*/}
            {/*        <div className={`jobs__more`}*/}
            {/*             onClick={() => this.toggleReviews(9)}>*/}
            {/*            {this.state.checked9 ? 'Скрыть' : 'Подробнее'}*/}
            {/*        </div>*/}
            {/*        <div className={`jobs__more`}*/}
            {/*             onClick={() => modalStore.openModalJobsForm('Контролер ОТК')}>*/}
            {/*            Откликнуться*/}
            {/*        </div>*/}
            {/*    </div>*/}
            {/*</div>*/}
            {/*<div className={`jobs__item`}>*/}
            {/*    <p className={`jobs__title js-jobs-title`}>*/}
            {/*        Заготовщик деталей и материалов к ювелирным и художественным изделиям*/}
            {/*    </p>*/}
            {/*    <Collapse in={this.state.checked10}*/}
            {/*              collapsedSize={55}*/}
            {/*    >*/}
            {/*        <p className={`jobs__subtitle`}>*/}
            {/*            Место работы:*/}
            {/*        </p>*/}
            {/*        <div className={`jobs__description`}>*/}
            {/*            <p>*/}
            {/*                Ювелирный завод в Красном-на-Волге (Костромская область)*/}
            {/*            </p>*/}
            {/*        </div>*/}
            {/*        <p className={`jobs__subtitle`}>*/}
            {/*            Новому сотруднику предстоит:*/}
            {/*        </p>*/}
            {/*        <div className={`jobs__description`}>*/}
            {/*            <p>*/}
            {/*                Переработка полуфабриката в заданные формы – полосы, проволоку в полном соответствии с*/}
            {/*                техпроцессом;*/}
            {/*            </p>*/}
            {/*            <p>*/}
            {/*                Выполнение процессов отжига, волочения и проката проволоки различных диаметров, ленты;*/}
            {/*            </p>*/}
            {/*            <p>*/}
            {/*                Резка металла с использованием электро- и иного оборудования.*/}
            {/*            </p>*/}
            {/*        </div>*/}
            {/*        <p className={`jobs__subtitle`}>*/}
            {/*            Требования:*/}
            {/*        </p>*/}
            {/*        <div className={`jobs__description`}>*/}
            {/*            <p>*/}
            {/*                Опыт работы от 1 года.*/}
            {/*            </p>*/}
            {/*        </div>*/}
            {/*        <p className={`jobs__subtitle`}>*/}
            {/*            Мы&nbsp;предлагаем:*/}
            {/*        </p>*/}
            {/*        <div className={`jobs__description`}>*/}
            {/*            <p>*/}
            {/*                Полная занятость, полный день;*/}
            {/*            </p>*/}
            {/*            <p>*/}
            {/*                Высокая сдельная заработная плата;*/}
            {/*            </p>*/}
            {/*            <p>*/}
            {/*                Полностью официальное оформление;*/}
            {/*            </p>*/}
            {/*            <p>*/}
            {/*                Профессиональный рост;*/}
            {/*            </p>*/}
            {/*            <p>*/}
            {/*                Доставка на работу транспортом предприятия.*/}
            {/*            </p>*/}
            {/*        </div>*/}
            {/*    </Collapse>*/}
            {/*    <div className={`jobs__buttons`}>*/}
            {/*        <div className={`jobs__more`}*/}
            {/*             onClick={() => this.toggleReviews(10)}>*/}
            {/*            {this.state.checked10 ? 'Скрыть' : 'Подробнее'}*/}
            {/*        </div>*/}
            {/*        <div className={`jobs__more`}*/}
            {/*             onClick={() => modalStore.openModalJobsForm('Заготовщик деталей и материалов к ювелирным и художественным изделиям')}>*/}
            {/*            Откликнуться*/}
            {/*        </div>*/}
            {/*    </div>*/}
            {/*</div>*/}
            {/*<div className={`jobs__item`}>*/}
            {/*    <p className={`jobs__title js-jobs-title`}>*/}
            {/*        Ювелир-монтировщик*/}
            {/*    </p>*/}
            {/*    <Collapse in={this.state.checked11}*/}
            {/*              collapsedSize={55}*/}
            {/*    >*/}
            {/*        <p className={`jobs__subtitle`}>*/}
            {/*            Место работы:*/}
            {/*        </p>*/}
            {/*        <div className={`jobs__description`}>*/}
            {/*            <p>*/}
            {/*                Ювелирный завод в Красном-на-Волге (Костромская область)*/}
            {/*            </p>*/}
            {/*        </div>*/}
            {/*        <p className={`jobs__subtitle`}>*/}
            {/*            Новому сотруднику предстоит:*/}
            {/*        </p>*/}
            {/*        <div className={`jobs__description`}>*/}
            {/*            <p>*/}
            {/*                Монтировка всего спектра ювелирных украшений.*/}
            {/*            </p>*/}
            {/*        </div>*/}
            {/*        <p className={`jobs__subtitle`}>*/}
            {/*            Требования:*/}
            {/*        </p>*/}
            {/*        <div className={`jobs__description`}>*/}
            {/*            <p>*/}
            {/*                Рассмотрим кандидатов с опытом работы и без опыта;*/}
            {/*            </p>*/}
            {/*            <p>*/}
            {/*                Знание лазерной пайки приветствуется.*/}
            {/*            </p>*/}
            {/*        </div>*/}
            {/*        <p className={`jobs__subtitle`}>*/}
            {/*            Мы&nbsp;предлагаем:*/}
            {/*        </p>*/}
            {/*        <div className={`jobs__description`}>*/}
            {/*            <p>*/}
            {/*                Полная занятость, полный день с 8.00 до 17.00;*/}
            {/*            </p>*/}
            {/*            <p>*/}
            {/*                Высокая сдельная заработная плата;*/}
            {/*            </p>*/}
            {/*            <p>*/}
            {/*                Официальное оформление;*/}
            {/*            </p>*/}
            {/*            <p>*/}
            {/*                Доставка транспортом предприятия.*/}
            {/*            </p>*/}
            {/*        </div>*/}
            {/*    </Collapse>*/}
            {/*    <div className={`jobs__buttons`}>*/}
            {/*        <div className={`jobs__more`}*/}
            {/*             onClick={() => this.toggleReviews(11)}>*/}
            {/*            {this.state.checked11 ? 'Скрыть' : 'Подробнее'}*/}
            {/*        </div>*/}
            {/*        <div className={`jobs__more`}*/}
            {/*             onClick={() => modalStore.openModalJobsForm('Ювелир-монтировщик')}>*/}
            {/*            Откликнуться*/}
            {/*        </div>*/}
            {/*    </div>*/}
            {/*</div>*/}
            {/*<div className={`jobs__item`}>*/}
            {/*    <p className={`jobs__title js-jobs-title`}>*/}
            {/*        Специалист на участок родажа*/}
            {/*    </p>*/}
            {/*    <Collapse in={this.state.checked12}*/}
            {/*              collapsedSize={55}*/}
            {/*    >*/}
            {/*        <p className={`jobs__subtitle`}>*/}
            {/*            Место работы:*/}
            {/*        </p>*/}
            {/*        <div className={`jobs__description`}>*/}
            {/*            <p>*/}
            {/*                Ювелирный завод в Красном-на-Волге (Костромская область)*/}
            {/*            </p>*/}
            {/*        </div>*/}
            {/*        <p className={`jobs__subtitle`}>*/}
            {/*            Новому сотруднику предстоит:*/}
            {/*        </p>*/}
            {/*        <div className={`jobs__description`}>*/}
            {/*            <p>*/}
            {/*                Выполнение процессов родажа ювелирных изделий в гальванических ваннах и гальваническим*/}
            {/*                карандашом;*/}
            {/*            </p>*/}
            {/*            <p>*/}
            {/*                Регулировку процессов родажа по приборам и заданным режимам;*/}
            {/*            </p>*/}
            {/*            <p>*/}
            {/*                Выполняет работу с растворами кислот, щелочей;*/}
            {/*            </p>*/}
            {/*            <p>*/}
            {/*                Контроль физико-химических свойств полуфабрикатов художественных изделий.*/}
            {/*            </p>*/}
            {/*        </div>*/}
            {/*        <p className={`jobs__subtitle`}>*/}
            {/*            Требования:*/}
            {/*        </p>*/}
            {/*        <div className={`jobs__description`}>*/}
            {/*            <p>*/}
            {/*                Желателен опыт работы на участке родажа.*/}
            {/*            </p>*/}
            {/*        </div>*/}
            {/*        <p className={`jobs__subtitle`}>*/}
            {/*            Мы&nbsp;предлагаем:*/}
            {/*        </p>*/}
            {/*        <div className={`jobs__description`}>*/}
            {/*            <p>*/}
            {/*                Полная занятость, полный день с 8.00 до 17.00;*/}
            {/*            </p>*/}
            {/*            <p>*/}
            {/*                Высокая сдельная заработная плата;*/}
            {/*            </p>*/}
            {/*            <p>*/}
            {/*                Официальное оформление;*/}
            {/*            </p>*/}
            {/*            <p>*/}
            {/*                Доставка транспортом предприятия.*/}
            {/*            </p>*/}
            {/*        </div>*/}
            {/*    </Collapse>*/}
            {/*    <div className={`jobs__buttons`}>*/}
            {/*        <div className={`jobs__more`}*/}
            {/*             onClick={() => this.toggleReviews(12)}>*/}
            {/*            {this.state.checked12 ? 'Скрыть' : 'Подробнее'}*/}
            {/*        </div>*/}
            {/*        <div className={`jobs__more`}*/}
            {/*             onClick={() => modalStore.openModalJobsForm('Специалист на участок родажа')}>*/}
            {/*            Откликнуться*/}
            {/*        </div>*/}
            {/*    </div>*/}
            {/*</div>*/}
        </>
    }
}

export default useWithStore(JobsItem);
